import { render, staticRenderFns } from "./adminMingxi.vue?vue&type=template&id=831838c6"
import script from "./adminMingxi.vue?vue&type=script&lang=js"
export * from "./adminMingxi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports